import { ModalBase } from "../../../components/Modals/ModalBase";
import BasicCardDocumentos from "../../OtrosDocumentos/Components/BasicCardDocumentos";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../../reducers";
import InputForm from "../../OtrosDocumentos/Components/InputFormV2";
import { useEffect, useMemo, useState } from "react";
import { formatDateToDDMMYYYY, validarAlfanumericoEspacios, validarRegexNumericoFloat2Decimales } from "../../../utils/strings.utils";
import { generalOpenModalError, generalOpenModalInfo, generalShowLoader } from "../../../actions/general.actions";
import { apiGetComprobante, apiSubirComprobante, suscripcionGetDatosSuscripcion, GetValidarSaldo } from "../../../actions/suscripcion/suscripcion.actions";
import { calculateFileSizeInMB } from "../../../utils/file";
import Tooltip from "../../../components/Inputs/Tooltip";
import VerComprobanteIcon from '../../../media/felsv/Open_Eye.svg'

export default function ModalComprobante ({onClose, data, visualizar} : {onClose: any, data: any, visualizar?: boolean}){
    const {bancos} = useSelector((state: State) => state.catalogos)
    const {datos} = useSelector((state: State) => state.userLogin)
    const {datosSuscripcion} = useSelector((state: State) => state.suscripcion)

    const dispatch = useDispatch()

    const [form, setForm] = useState<{[key:string] : any}>({
        banco: '',
        autorizacion: '',
        factura: data?.numerofactura || 'N/A',
        comprobante: '',
        pago: '',
        monto: data?.montopago,
        montoOriginal: data?.montopago,
    })

    const [errors, setErrors] = useState<{[key:string] : any}>({
        banco: '',
        autorizacion: '',
        factura: '',
        comprobante: '',
        pago: '',
        monto: '',
        montoOriginal: '',
    })

    const [comprobante, setComprobante] = useState<any>('')

    const [urlFile, setUrlFile] = useState('')

    const [detalles, setDetalles] = useState<any>('')
    const [detallesParciales, setDetallesParciales] = useState<any>('')

    const onChangeForm = (e: any) => {
        let name = e.target.name
        let value = e.target.value

        switch(name){
            case 'autorizacion':
            case 'factura':
                if(!validarAlfanumericoEspacios(value)) return
                break;
            case 'monto':
                if(!validarRegexNumericoFloat2Decimales(value)) return
                break;
        }

        validateForm(name, value)

        setForm({
            ...form,
            [name] : value
        })

    }

    const onChangeComprobante = (e: any) => {
        try {
            const selectedFile = e.target.files[0]
            if(selectedFile){
                const reader = new FileReader();
                setForm({
                    ...form,
                    comprobante: e?.target?.value
                })

                reader.onload = () => {
                    const fileExtension = selectedFile.name.slice(selectedFile.name.lastIndexOf('.'));
                    const validTypes = ['.pdf']
                    

                    // Validar tamaño
                    if (selectedFile.size > 2097152) { // 2MB en bytes
                      setErrors({
                        ...errors,
                        comprobante: 'El tamaño del comprobante debe ser menor o igual a 2MB.'
                      });
                      return;
                    }

                    if(!validTypes.includes(fileExtension.toLowerCase())){
                        setErrors({
                            ...errors,
                            comprobante: 'Por favor, selecciona un archivo con una extensión válida. (.pdf)'
                        })
                        return;
                    }
                    setErrors({
                        ...errors,
                        comprobante: ''
                    })
                }

                reader.onloadend = () => {
                    
                    if(typeof reader.result === 'string'){
                        const base64file = reader.result.split(',')[1];
                        setComprobante(base64file) 
                    }
                }
                reader.readAsDataURL(selectedFile)
            } else {
                setForm({
                    ...form,
                    comprobante: ''
                })
            }
        } catch (error) {
            dispatch(generalOpenModalError('Ocurrió un error al cargar el comprobante, intenta cargarlo nuevamente.'))
        }
    }



    const validateForm = (name: string, value: string) => {
        let message = ''

        switch(name){
            case 'banco':
                if(!value) message = 'Banco es requerido'
                break;
            case 'autorizacion':
                if(value?.trim() === '') message = 'Autorización es requerida'
                break;
            // case 'factura':
            //     if(value?.trim() === '') message = 'Factura es requerida'
            //     break;
            case 'comprobante':
                if(value?.trim() === '') message = 'Comprobante es requerido'
                else message = errors.comprobante
                break;
            case 'pago':
                let hoy = new Date()
                let fecha = new Date(value)
                if(fecha > hoy){
                    message = 'La fecha de pago no puede ser mayor a la fecha actual';
                    break;
                }
                if(value?.trim() === '') message = 'Fecha de pago es requerida'
                break;
            case 'monto':
                if(value?.trim() === '') message = 'Monto es requerido'
                else if(parseFloat(value) > parseFloat(form.montoOriginal)) message = `Monto no puede exceder el valor actual (${form.montoOriginal}).`
                break;
        }

        setErrors({
            ...errors,
            [name] : message
        })
        return message;
    }
    


    const onClickSubir = async() => {
        let validations: {[key:string] : any} = {}

        for(const field in form){
            validations[field] = validateForm(field, form[field])
        }
        
        setErrors(validations)

        if(Object.values(validations).some((validation) => validation !== '')) return;

        try {
            dispatch(generalShowLoader(true))
            const body = {
                codigoempresa: datos?.codigo_empresa,
                descripcion: 'Actualizacion de comprobante sitio cliente',
                idbanco: form.banco,
                numautorizacion: form.autorizacion,
                pago: {
                    iddetalleestadopago: data?.iddetalleestadopago,
                    numerofactura: form.factura,
                    fechapago: form.pago,
                    monto: form.monto
                },
                username: datos?.username,
                documento: comprobante,
                clienteNuevo: false,
            }
            const response: any = await apiSubirComprobante(body)
            if(response.status === 200){
                dispatch(generalOpenModalInfo(response.message ?? 'El comprobante fue actualizado exitosamente.'))
                onClose()
                dispatch(suscripcionGetDatosSuscripcion())
                dispatch(GetValidarSaldo())
            }
        } catch (error) {
            dispatch(generalOpenModalError('Ocurrió un error al guardar el comprobante'))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const cargarDatosComprobante = async() => {
        
        try {
            dispatch(generalShowLoader(true))
            const response: any = await apiGetComprobante({
                iddetalleestadopago: data?.iddetalleestadopago,
                iddetallecomprobante: data?.iddetallecomprobante,
                codigoempresa: datos?.codigo_empresa
            })
            setComprobante(response?.data?.comprobante)
            setUrlFile(response?.data?.base64)
            setDetalles(response?.data?.detalle?.DetalleEstadoComprobante);
            setDetallesParciales(response?.data?.detalle?.DetallePagosParciales);
        } catch (error) {
            dispatch(generalOpenModalError('Ocurrió un error al cargar los datos del comprobante'))
            onClose()
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const handleLoadComprobante = async(pago: any) => {
        try {
            dispatch(generalShowLoader(true))
            const response: any = await apiGetComprobante({
                iddetalleestadopago: data?.iddetalleestadopago,
                iddetallecomprobante: data?.iddetallecomprobante,
                idsuscripcioncomprobante: pago?.idsuscripcioncomprobante,
                codigoempresa: datos?.codigo_empresa,
            })
            setUrlFile(response?.data?.base64)
        } catch (error) {
            dispatch(generalOpenModalError('Ocurrió un error al cargar los datos del comprobante'))
            onClose()
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const fileSizeLarge = useMemo(() => {
        const sizeFile = calculateFileSizeInMB(urlFile);
        return sizeFile > 2;
    }, [urlFile]);

    const downloadPdf = async () => {
        try {
          const response = await fetch(`data:application/pdf;base64,${urlFile}`);
          const blob = await response.blob();
    
          // Crear una URL de objeto (Blob) para descargar el archivo
          const blobUrl = URL.createObjectURL(blob);
    
          // Crear un enlace invisible y simular un clic para descargar el archivo
          const link = document.createElement('a');
          link.href = blobUrl;
          link.download = `comprobante${data?.numerofactura ? `_factura_No_${data.numerofactura}` : ''}.pdf`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
    
          // Liberar la URL del objeto después de la descarga
          URL.revokeObjectURL(blobUrl);
        } catch (error) {
          console.error('Error al descargar el archivo:', error);
        }
    };

    useEffect(() => {
        if(visualizar){
            cargarDatosComprobante()
        }
    }, [])

    return(
        <ModalBase>
            {visualizar ?
            <BasicCardDocumentos title="Ver comprobante">
                {
                    detallesParciales?.length > 0 && <DetallePagosParciales data={detallesParciales} bancos={bancos} onLoadComprobante={handleLoadComprobante}/>
                }
                <div>
                    <div style={{background: detalles?.EstadoComprobante?.color, color: 'white', padding: '10px', textAlign: 'center'}}>{detalles?.EstadoComprobante?.nombre}</div>
                    <div style={{display: 'flex', justifyContent: 'center', border: `1px solid ${detalles?.EstadoComprobante?.color ?? 'white'}`, padding: '10px', borderRadius: '0 0 4px 4px'}}>{detalles?.observaciones !== ""? detalles?.observaciones : 'Sin observaciones'}</div>
                </div>
                <div>
                    {
                        urlFile && 
                        (
                            <>
                                {!fileSizeLarge 
                                    ? 
                                        <object
                                            style={{width: '100%', height: '400px'}}
                                            data = {`data:application/pdf;base64,${urlFile}`}
                                            type="application/pdf"
                                        >
                                            <p>No se puede mostrar el pdf, puedes descargarlo en su lugar</p>
                                        </object>
                                    :
                                        <p style={{textAlign: 'center'}}>
                                            El archivo excede el tamaño para su visualización. 
                                            <br/>
                                            Haz click en el botón de abajo para iniciar la descarga.
                                        </p>
                                }
                            </>
                        )
                    }
                </div>
                <div style={{display: 'flex', gap: '20px'}}>
                    <button onClick={onClose} className="button transparent">Cerrar</button>
                    <button className="button" onClick={downloadPdf}>Descargar comprobante</button>
                </div>
            </BasicCardDocumentos>
            :
            <BasicCardDocumentos title= "Subir comprobante">
                    <div className="form-content">
                    <div className="w-layout-hflex h-inputs">
                    <InputForm options = {bancos} keyNameText = 'nombre' keyNameValue = 'idbanco' name = 'banco' placeholder = 'Banco' label = 'Banco' type = 'select' value = {form.banco} error = {errors.banco} onChange = {(e: any) => onChangeForm({target: {name: 'banco',value: e.value}})}/>
                    <InputForm placeholder = 'No. Autorización' label="No. Autorización" type="text" value={form.autorizacion} name="autorizacion" error={errors.autorizacion} onChange={onChangeForm}/>
                    </div>
                    <div className="w-layout-hflex h-inputs">
                    <InputForm disabled placeholder = 'Factura' label="Factura" type="text" value={form.factura} name="factura" error={errors.factura} onChange={onChangeForm}/>
                    <InputForm accept = ".pdf" containerClassname = 'file-input' inputClassname = 'text-field w-input upload_file_input' placeholder = 'Comprobante' label="Comprobante" type="file" value={form.comprobante} name="comprobante" error={errors.comprobante} onChange={onChangeComprobante}/>
                    </div>
                    <div className="w-layout-hflex h-inputs">
                    <InputForm label="Fecha de pago" type="date" value={form.pago} name="pago" error={errors.pago} onChange={onChangeForm}/>
                    <InputForm placeholder = '$0.00' label="Monto" type="text" value={form.monto} name="monto" error={errors.monto} onChange={onChangeForm}/>
                    </div>
                    </div>
                <hr className="separador"/>
                <div style={{display: 'flex', gap: '20px'}}>
                    <button onClick={onClose} className="button transparent">Cancelar</button>
                    <button onClick={onClickSubir} className="button">Subir</button>
                </div>
            </BasicCardDocumentos>
            }
        </ModalBase>
    )
}

const DetallePagosParciales = ({data, bancos, onLoadComprobante} : {data: any, bancos: any, onLoadComprobante: any}) => {
    return (
        <>
            <div className="w-layout-hflex">
                <h3 className='card-title m'>Detalle de pagos</h3> 
            </div>
            <div className="tab-plane" style={{padding: '30px', borderRadius: '8px', boxShadow: '0px 4px 40px 0px rgba(9, 22, 56, 0.15)', overflow: 'auto'}}>
                <table className="table-main-responsive responsive-table-main td-left table-pointer">
                    <thead>
                        <tr>
                            <td>Acciones</td>
                            <td>Estado de pago</td>
                            <td>Monto</td>
                            <td>Fecha</td>
                            <td>Banco</td>
                            <td>Autorización</td>
                        </tr>
                    </thead>
                    <tbody>
                        {data?.map((pago: any) => (
                        <tr>
                            <td data-label = 'Acciones'>
                                <Tooltip text="Ver comprobante">
                                    <button onClick={() => onLoadComprobante(pago)} className='table-action'>
                                        <img className='table-img-action' style={{height: '14px', width: '14px', borderRadius: '100px'}} src={VerComprobanteIcon}/>
                                    </button>
                                </Tooltip>
                            </td>
                            <td data-label = 'Estado pago'>
                                <div className="btn-estado-suscripcion" style={{textAlign: 'center',...getColorStyle(pago?.EstadoPago?.color)}}>{pago?.EstadoPago?.nombre}</div>
                            </td>
                            <td data-label = 'Monto'>{parseFloat(pago?.montopago)?.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})}</td>
                            <td data-label = 'Fecha'>{formatDateToDDMMYYYY(pago?.SuscripcionComprobante?.fechapago)}</td>
                            <td data-label = 'Banco'>{bancos.find((banco: any) => banco?.idbanco === pago?.SuscripcionComprobante?.idbanco)?.nombre}</td>
                            <td data-label = 'Autorización'>{pago?.SuscripcionComprobante?.numautorizacion}</td>
                        </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="separador"></div>
        </>
    )
}

const getColorStyle = (color: string) => {
    return {background: color, color: 'white', borderRadius: '100px', padding: '10px', maxWidth: '200px'}
}